import { useEffect, useRef, useState, type FormEvent } from 'react';
import { LIMITS } from '@shared/protocol.js';
import type { ChatMessage } from '@/lib/net';
import { IconClose } from '../icons';

export default function ChatPanel({
  messages, onSend, onClose, myId,
}: {
  messages: ChatMessage[];
  onSend: (body: string) => void;
  onClose: () => void;
  myId: string;
}) {
  const [draft, setDraft] = useState('');
  const logRef = useRef<HTMLDivElement>(null);

  // Stick to the bottom as messages arrive.
  useEffect(() => {
    const el = logRef.current;
    if (el) el.scrollTop = el.scrollHeight;
  }, [messages.length]);

  const submit = (e: FormEvent) => {
    e.preventDefault();
    const body = draft.trim();
    if (!body) return;
    onSend(body);
    setDraft('');
  };

  return (
    <div className="chat">
      <div className="row row--between" style={{ padding: '10px 12px', borderBottom: '1px solid var(--line)' }}>
        <strong style={{ fontSize: 14 }}>Chat</strong>
        <button type="button" className="pill-btn pill-btn--sm" onClick={onClose} aria-label="Close chat">
          <IconClose size={18} />
        </button>
      </div>

      <div className="chat__log" ref={logRef}>
        {messages.length === 0 ? (
          <p className="tiny muted center" style={{ margin: 'auto 0' }}>
            Nothing said yet. Say hello.
          </p>
        ) : messages.map((msg) => (
          <div key={msg.id} className="chat__msg">
            <span
              className="chat__who"
              style={{ color: msg.userId === myId ? 'var(--accent)' : msg.color }}
            >
              {msg.userId === myId ? 'You' : msg.username}
            </span>
            <span className="selectable">{msg.body}</span>
          </div>
        ))}
      </div>

      <form className="chat__form" onSubmit={submit}>
        <input
          className="input grow"
          style={{ height: 40 }}
          value={draft}
          maxLength={LIMITS.maxChatLength}
          onChange={(e) => setDraft(e.target.value)}
          placeholder="Say something…"
          aria-label="Message"
        />
        <button type="submit" className="btn btn--sm btn--accent" disabled={!draft.trim()}>Send</button>
      </form>
    </div>
  );
}
